import * as React from 'react'
import * as classNames from 'classnames'

import * as Style from './style.css'

type IButtonType = typeof BUTTON_TYPE_PINK | typeof BUTTON_TYPE_BLUE

export interface IProps {
  buttonType: IButtonType
  accordionTitle1: string
  accordionTitle2: string
  href: string
  pageTransitionHandler: (href: string) => void
}

export const BUTTON_TYPE_PINK = 'PINK'
export const BUTTON_TYPE_BLUE = 'BLUE'

export const ColorButton = React.forwardRef<HTMLInputElement, IProps>(
  (
    {
      buttonType,
      accordionTitle1,
      accordionTitle2,
      href,
      pageTransitionHandler,
      ...props
    },
    ref,
  ) => {
    const buttonClass = {
      [Style.ColorButtonSitter]: buttonType === BUTTON_TYPE_PINK,
      [Style.ColorButtonHousekeeping]: buttonType === BUTTON_TYPE_BLUE,
    }

    return (
      <button
        className={classNames(buttonClass)}
        type="button"
        onClick={() => pageTransitionHandler(href)}
      >
        <div className={Style.ColorButtonTitle1}>{accordionTitle1}</div>
        <div className={Style.ColorButtonTitle2}>{accordionTitle2}</div>
      </button>
    )
  },
)
